export default __webpack_public_path__ + "static/media/main-team2.20a1e60f.jpg";